import React, { useState, useEffect } from "react";
import Button from "../../../../Components/Buttons/Button";
import Discount from "../../../../APIController/Discount";
import DiscountForm from "../Forms/DiscountForm";
import { useModal } from "../../../../Components/Modal";
import Text from "../../../../Components/Text";
import Icon from "../../../../Components/Icon";
import CrudPage from "../../../../Components/CrudPage";

function DiscountManagement() {
    const { fetchDiscount, deleteDiscount } = Discount()

    /* Modal Loader */
    const { ModalView, openModal, closeModal } = useModal()

    const [discounts, setDiscounts] = useState([])

    useEffect(() => {
        fetchDiscountData();
    }, [])

    const fetchDiscountData = async () => {
        const data = await fetchDiscount()
        setDiscounts(data)
    }

    const formActions = () => {
        fetchDiscountData()
        closeModal()
    }
    
    const handleAddClick = (e) => {
        e.preventDefault();
        openModal(<DiscountForm afterAction={() => formActions()} />)
    }

    const handleDeleteClick = async (e, discount) => {
        await deleteDiscount(discount.id)
        fetchDiscountData()
    }

    const MainView = () => (
        <>
            <CrudPage
                title={"Rabatte"}
                items={discounts}
                crudActions={[
                    { type: "create", color: "bg-white", action: handleAddClick },
                    { type: "delete", color: "red", action: handleDeleteClick, icon: "trash" }]}
                displayMethod={(discount) => (
                    <>
                        <Text type="itemmain">{discount.percentage}%</Text>
                    </>
                )}
            />
            <ModalView classNames="w-auto" />
        </>
    )

    return (MainView())
}

export default DiscountManagement